export default __webpack_public_path__ + "static/media/loginBg.501e3747.jpg";